import React, {useState, useCallback, useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import Tooltip from "components/tooltips/Tooltips";

function Tabs({children}) {
    const pathname = useLocation().pathname;
    const navigate = useNavigate()
    const navigateLink = (label) => {
        if(label === 'contract'){
            return 'contract/toBeSigned'
        }
        else if(label === 'invoices'){
            return 'invoices/toBeSet'
        }
        else{
            return label
        }
    }

    const tabs = children.map(child => {
        const isDisabled = child.props.disabled === true;
        const tabEl = (
        <div
            onClick={e => {
            if (isDisabled) {
                e.preventDefault();
                return;
            }
            e.preventDefault()
            navigate(`./${navigateLink(child.props.label)}`,{replace:true})
        }}
             className={`h-full flex items-end px-4 pb-0 ${isDisabled ? 'cursor-not-allowed text-gray-400' : 'cursor-pointer'} ${pathname.includes(child.props.label) && !isDisabled ? 'border-b-2 border-b-yellow-500 text-yellow-500' : !isDisabled ? 'hover:border-b-2 hover:border-b-gray-500' : ''}`}
        >
            <span className="pb-4 text-sm">{child.props.tabName}</span>
        </div>
        );

        if (isDisabled) {
            return (
                <Tooltip key={child.props.label} text="Bientôt disponible" placement="top">
                    {tabEl}
                </Tooltip>
            );
        }

        return React.cloneElement(tabEl, { key: child.props.label });
    })

    const tabContent = children.filter(child => pathname.includes(child.props.label))
    return (
        <div className="h-full flex items-end">
            <div className='flex gap-4 bg-white'>{tabs}</div>
            <div className='hidden'>{tabContent}</div>
        </div>
    )
}

function Tab(props) {
    return <>{props.children}</>
}

export {Tabs, Tab}